const Popup = ((($) => {
  let zoomGallery;
  let options;

  function init() {
    zoomGallery = $('.popupbox');
    options = {
      locked : false
    };
    zoomGallery.fancybox(options);
  }

  return {
    init,
  };
}))(jQuery);

export default Popup;



// WEBPACK FOOTER //
// ./src/static/js/modules/popup.js